export const categories = [
  [
    {
      id: "featured",
      value: "featured"
    }, {
      id: "portraits",
      value: "portraits"
    }, {
      id: "street",
      value: "street"
    }, {
      id: "documentary",
      value: "documentary"
    }
  ],
  [
    {
      id: "stilllife",
      value: "still life"
    }, {
      id: "landscape",
      value: "landscape"
    }, {
      id: "other",
      value: "other"
    }
  ]
]



// WEBPACK FOOTER //
// ./src/helpers/const.js